import AllImports from "./AllImports";

const AdminImport = () => {

  return (
    <>
      <h5 className="m-0 mb-4">Imports</h5>
      <AllImports adminImport={true} />
    </>

  )
}

export default AdminImport;